import { RadioButtonOption } from "../../../common/enums";

export const ELECTRIC_DISCONNECTION_CHECKLIST_VERSION_2026_02 = 1;

export type ElectricDisconnectionChecklist = {
    checklistVersion: number | undefined;
    responsibleElectricianName: string;
    responsibleElectricianPhoneNumber: string;
    equipmentIsConnectedToEarthFaultBreaker: RadioButtonOption;
    electricConnectionsAreAboveGround: RadioButtonOption;
    powerIsCutAndFusesRemoved: RadioButtonOption;
    cablesAreWithoutRiskOfFalling: RadioButtonOption;
    signIsAtElectricalBreaker: RadioButtonOption;
};

